$(function () {
	new Swiper('#reasonTwoSwiper', {
		loop: true,
		speed: 1100,
		autoplay: {
			delay: 3000,
		},
		navigation: {
			nextEl: '.reasonTwo_r',
			prevEl: '.reasonTwo_l',
		},
		pagination: {
			el: '.reasonTwo_pagination',
			clickable: true,
		},
	})
	new Swiper('.book_swiper', {
		autoplay: {
			delay: 3000,
			disableOnInteraction: false,
		},
		loop: true,
		slidesPerView: 'auto',
		pagination: {
			el: '.book_pagination',
			clickable: true,
		},
	})
	new Swiper('.keep_container', {
		loop: true,
		autoplay: {
			delay: 3000,
		},
		speed: 1000,
		navigation: {
			nextEl: '.keep_next',
			prevEl: '.keep_prev',
		},
	})
	//预约2
	$('.form2 .kuang_city .current').click(function () {
		$('.form2 .kuang_city .list').show()
	})
	$('.form2 .kuang_city .option').click(function () {
		var _this = $(this)

		$('.form2 .kuang_city .current').text(_this.text())
		$('.form2 .city02').val(_this.text())
		$('.form2 .kuang_city .list').hide()
	})

	//预约1
	$('.form1 .kuang_city .current').click(function () {
		$('.form1 .kuang_city .list').show()
	})
	$('.form1 .kuang_city .option').click(function () {
		var _this = $(this)

		$('.form1 .kuang_city .current').text(_this.text())
		$('.form1 .city01').val(_this.text())
		$('.form1 .kuang_city .list').hide()
	})

	//底部预约
	$('.form3 .kuang_city .current').click(function () {
		$('.form3 .kuang_city .list').show()
	})
	$('.form3 .kuang_city .option').click(function () {
		var _this = $(this)

		$('.form3 .kuang_city .current').text(_this.text())
		$('.form3 .city01').val(_this.text())
		$('.form3 .kuang_city .list').hide()
	})

	$('.guanbi').click(function () {
		$('.form3').hide()
	})

	$('.choose_btn_list').click(function () {
		var top1 = $('.box5').offset().top
		$('html,body').animate({
			scrollTop: top1,
		})
	})

	//测边预约
	$('.form4 .course .currentCourse').click(function () {
		$('.form4 .course .list').show()
	})
	$('.form4 .course .option').click(function () {
		var _this = $(this)

		$('.form4 .course .currentCourse').text(_this.text())
		$('.form4 .form_course').val(_this.text())
		$('.form4 .course .list').hide()
	})

	$('.form4 .kuang_city .current').click(function () {
		$('.form4 .kuang_city .list').show()
	})
	$('.form4 .kuang_city .option').click(function () {
		var _this = $(this)

		$('.form4 .kuang_city .current').text(_this.text())
		$('.form4 .city04').val(_this.text())
		$('.form4 .kuang_city .list').hide()
	})

	$('.guanbi2').click(function () {
		$('.form4').hide()
	})
})
